module.exports = __webpack_public_path__ + "img/swift.c6d13209.svg";